function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "71.5092711%",
  y2: "8.62486884%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E38E0B",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD934",
  offset: "44.8925217%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFEE9",
  offset: "100%"
})), /*#__PURE__*/React.createElement("circle", {
  id: "path-2",
  cx: 50,
  cy: 50,
  r: 48
}), /*#__PURE__*/React.createElement("filter", {
  x: "-5.2%",
  y: "-5.2%",
  width: "110.4%",
  height: "110.4%",
  filterUnits: "objectBoundingBox",
  id: "filter-3"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1   0 0 0 0 0.811764706   0 0 0 0 0.0784313725  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 2,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadInner2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowSpreadInner2",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.95   0 0 0 0 0.6175   0 0 0 0 0  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("ellipse", {
  id: "path-4",
  cx: 34,
  cy: 7,
  rx: 6,
  ry: 7
}), /*#__PURE__*/React.createElement("filter", {
  x: "-33.3%",
  y: "-28.6%",
  width: "166.7%",
  height: "157.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-5"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.768627451   0 0 0 0 0.396078431   0 0 0 0 0.00392156863  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 2,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadInner2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  in: "shadowSpreadInner2",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("ellipse", {
  id: "path-6",
  cx: 6,
  cy: 7,
  rx: 6,
  ry: 7
}), /*#__PURE__*/React.createElement("filter", {
  x: "-33.3%",
  y: "-28.6%",
  width: "166.7%",
  height: "157.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-7"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.768627451   0 0 0 0 0.396078431   0 0 0 0 0.00392156863  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 2,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadInner2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  in: "shadowSpreadInner2",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("rect", {
  id: "path-8",
  x: 0,
  y: 0,
  width: 64,
  height: 18,
  rx: 8
}), /*#__PURE__*/React.createElement("filter", {
  x: "-6.2%",
  y: "-22.2%",
  width: "112.5%",
  height: "144.4%",
  filterUnits: "objectBoundingBox",
  id: "filter-9"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.768627451   0 0 0 0 0.396078431   0 0 0 0 0.00392156863  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadInner2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.5,
  in: "shadowSpreadInner2",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("radialGradient", {
  cx: "50%",
  cy: "50%",
  fx: "50%",
  fy: "50%",
  r: "106.5606%",
  gradientTransform: "translate(0.500000,0.500000),scale(0.245902,1.000000),rotate(90.000000),scale(1.000000,2.011527),translate(-0.500000,-0.500000)",
  id: "radialGradient-10"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D4D4D4",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.48350878,1.5 L55.9836865,1.5 L55.9836865,1.5 C59.5825471,1.5 62.5,4.41745293 62.5,8.0163135 L62.5,9.9836865 C62.5,13.5825471 59.5825471,16.5 55.9836865,16.5 L8.48350878,16.5 L8.48350878,16.5 C4.62662338,16.5 1.5,13.3733766 1.5,9.51649122 L1.5,8.48350878 C1.5,4.62662338 4.62662338,1.5 8.48350878,1.5 Z",
  id: "path-11"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-4.9%",
  y: "-20.0%",
  width: "109.8%",
  height: "140.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-12"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-4.9%",
  y: "-20.0%",
  width: "109.8%",
  height: "140.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-13"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowInnerInner1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2,9 L62,9",
  id: "path-14"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-3.3%",
  y: "-150.0%",
  width: "106.7%",
  height: "400.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-15"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M32,2 L32,8",
  id: "path-16"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-150.0%",
  y: "-33.3%",
  width: "400.0%",
  height: "166.7%",
  filterUnits: "objectBoundingBox",
  id: "filter-17"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M44.5,2 L44.5,8",
  id: "path-18"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-150.0%",
  y: "-25.0%",
  width: "300.0%",
  height: "150.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-19"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.5,
  dy: 0,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.5,
  dy: 0,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M56.5,2 L56.5,8",
  id: "path-20"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-150.0%",
  y: "-25.0%",
  width: "300.0%",
  height: "150.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-21"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.5,
  dy: 0,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.5,
  dy: 0,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M56.5,10 L56.5,16",
  id: "path-22"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-150.0%",
  y: "-25.0%",
  width: "300.0%",
  height: "150.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-23"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.5,
  dy: 0,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.5,
  dy: 0,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M44.5,10 L44.5,16",
  id: "path-24"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-150.0%",
  y: "-25.0%",
  width: "300.0%",
  height: "150.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-25"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.5,
  dy: 0,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.5,
  dy: 0,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20,10 L20,16",
  id: "path-26"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-50.0%",
  y: "-25.0%",
  width: "300.0%",
  height: "150.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-27"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 0,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 0,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20,2 L20,8",
  id: "path-28"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-50.0%",
  y: "-25.0%",
  width: "300.0%",
  height: "150.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-29"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 0,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 0,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8,2 L8,8",
  id: "path-30"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-50.0%",
  y: "-25.0%",
  width: "300.0%",
  height: "150.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-31"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 0,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 0,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8,10 L8,16",
  id: "path-32"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-50.0%",
  y: "-25.0%",
  width: "300.0%",
  height: "150.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-33"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 0,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 0,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M32,10 L32,16",
  id: "path-34"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-150.0%",
  y: "-33.3%",
  width: "400.0%",
  height: "166.7%",
  filterUnits: "objectBoundingBox",
  id: "filter-35"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "eek",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval-Copy"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#linearGradient-1)",
  fillRule: "evenodd",
  xlinkHref: "#path-2"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-3)",
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(30.000000, 34.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FD9B0A",
  fillRule: "evenodd",
  xlinkHref: "#path-4"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-5)",
  xlinkHref: "#path-4"
})), /*#__PURE__*/React.createElement("g", {
  id: "Oval-Copy-3"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FD9B0A",
  fillRule: "evenodd",
  xlinkHref: "#path-6"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-7)",
  xlinkHref: "#path-6"
}))), /*#__PURE__*/React.createElement("g", {
  id: "mouth",
  transform: "translate(18.000000, 58.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FD9B0A",
  fillRule: "evenodd",
  xlinkHref: "#path-8"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-9)",
  xlinkHref: "#path-8"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-Copy"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-12)",
  xlinkHref: "#path-11"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#radialGradient-10)",
  fillRule: "evenodd",
  xlinkHref: "#path-11"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-13)",
  xlinkHref: "#path-11"
})), /*#__PURE__*/React.createElement("g", {
  id: "Line",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-15)",
  xlinkHref: "#path-14"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#9B5802",
  strokeWidth: 1,
  xlinkHref: "#path-14"
})), /*#__PURE__*/React.createElement("g", {
  id: "Line-2",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-17)",
  xlinkHref: "#path-16"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#979797",
  strokeWidth: 1,
  xlinkHref: "#path-16"
})), /*#__PURE__*/React.createElement("g", {
  id: "Line-2-Copy-2",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-19)",
  xlinkHref: "#path-18"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#979797",
  strokeWidth: 1,
  xlinkHref: "#path-18"
})), /*#__PURE__*/React.createElement("g", {
  id: "Line-2-Copy-3",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-21)",
  xlinkHref: "#path-20"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#979797",
  strokeWidth: 1,
  xlinkHref: "#path-20"
})), /*#__PURE__*/React.createElement("g", {
  id: "Line-2-Copy-4",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-23)",
  xlinkHref: "#path-22"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#979797",
  strokeWidth: 1,
  xlinkHref: "#path-22"
})), /*#__PURE__*/React.createElement("g", {
  id: "Line-2-Copy-5",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-25)",
  xlinkHref: "#path-24"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#979797",
  strokeWidth: 1,
  xlinkHref: "#path-24"
})), /*#__PURE__*/React.createElement("g", {
  id: "Line-2-Copy-6",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-27)",
  xlinkHref: "#path-26"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#979797",
  strokeWidth: 1,
  xlinkHref: "#path-26"
})), /*#__PURE__*/React.createElement("g", {
  id: "Line-2-Copy-7",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-29)",
  xlinkHref: "#path-28"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#979797",
  strokeWidth: 1,
  xlinkHref: "#path-28"
})), /*#__PURE__*/React.createElement("g", {
  id: "Line-2-Copy-8",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-31)",
  xlinkHref: "#path-30"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#979797",
  strokeWidth: 1,
  xlinkHref: "#path-30"
})), /*#__PURE__*/React.createElement("g", {
  id: "Line-2-Copy-9",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-33)",
  xlinkHref: "#path-32"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#979797",
  strokeWidth: 1,
  xlinkHref: "#path-32"
})), /*#__PURE__*/React.createElement("g", {
  id: "Line-2-Copy",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-35)",
  xlinkHref: "#path-34"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#979797",
  strokeWidth: 1,
  xlinkHref: "#path-34"
}))));

var SvgEek = function SvgEek(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEek, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eek.604e4e2a.svg";
export { ForwardRef as ReactComponent };